import { useCallback, useState } from "react";
import { openSnapZegoFilteredCaptureTest } from "../plugins/NativeLivoraCall";
import "./SnapZegoFilteredCaptureTestButton.css";

export default function SnapZegoFilteredCaptureTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenTest = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openSnapZegoFilteredCaptureTest();
      console.log("[snapZegoFilteredCaptureTest] result", result);
    } catch (error) {
      console.log("[snapZegoFilteredCaptureTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="snap-zego-filtered-capture-test-btn"
      onClick={handleOpenTest}
      disabled={busy}
      aria-label="Open Snap Zego Filtered Capture Test"
    >
      Open Snap Zego Filtered Capture Test
    </button>
  );
}
